import React, { Component } from "react";
import ModalVideo from "react-modal-video";
import 'react-modal-video/scss/modal-video.scss';
import './css/Home.css';

export class VideoModal extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }
  render() {
    return (
      <div>
        <div>
          <ModalVideo
            channel="youtube"
            isOpen={this.state.isOpen}
            videoId="TJlpS4vhKP0"
            onClose={() => this.setState({ isOpen: false })}
          />
          <div className="playbtncontainer">
          <button onClick={this.openModal} className="playbtn">
            <img className="playTriangle" src={process.env.PUBLIC_URL + '/digitalassets/play.png'} />
            <span className="playtext">Watch the Intro</span>
          </button>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoModal;